export enum ErrorCode {
    MISSING_RECAPTCHA_CODE = 1001,
    RECAPTCHA_VERIFICATION_FAILED = 1002,

    MISSING_COMPANY_TYPE = 1003,

    PUBLIC_REQUEST_MISSING_TOKEN = 6001,
    PUBLIC_REQUEST_INVALID_TOKEN = 6002,
    PUBLIC_REQUEST_MISMATCHED_TOKEN = 6003,
    PUBLIC_REQUEST_MISSING_REQUEST_MASTER_TYPE = 6004,
    PUBLIC_REQUEST_UNSUPPORTED_REQUEST_MASTER_TYPE = 6005,
    PUBLIC_REQUEST_MISMATCHED_REQUEST_MASTER_TYPE = 6006,
    PUBLIC_REQUEST_INVALID_FORM_CONTRACT_OR_PROPOSAL_ID = 6007,
    PUBLIC_REQUEST_INVALID_FORM_VALUES = 6008,
    PUBLIC_REQUEST_MISMATCHED_FORM_VALUES = 6009,
    PUBLIC_REQUEST_INVALID_TOKEN_METADATA_REQUEST_TYPE_ID = 6010,
    PUBLIC_REQUEST_INVALID_TOKEN_METADATA_CONTRACT_OR_PROPOSAL_ID = 6011,
    PUBLIC_REQUEST_INVALID_CONTRACT = 6012,
    PUBLIC_REQUEST_SAVE_FAILED = 6013,
    PUBLIC_REQUEST_SUBMIT_FAILED = 6014,
    PUBLIC_REQUEST_MARK_FAILED = 6015,

    PUBLIC_REQUEST_DOCUMENT_NOT_FOUND_OR_FORBIDDEN = 6016
}
